function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1972(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.85,
    height: 14.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9786666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 7.34,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.68,
    width: 22.85,
    height: 17.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4966666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 23.66,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.63,
    width: 22.85,
    height: 19.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.757272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 42.295,
    fontFamily: "Arial"
  }, "\n        Norton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51.96,
    width: 22.85,
    height: 20.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.305625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 62.405,
    fontFamily: "Arial"
  }, "\n        Buena_Vista_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 72.85,
    width: 22.85,
    height: 22.73,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7484615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 84.21499999999999,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 95.58,
    width: 22.85,
    height: 22.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1984210526315788
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 106.965,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 118.35,
    width: 22.85,
    height: 24.08,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0772727272727276
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 130.39,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 142.43,
    width: 22.85,
    height: 25.54,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2026315789473685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 155.20000000000002,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 167.97,
    width: 22.85,
    height: 26.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0880952380952382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 181.01,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 194.05,
    width: 22.85,
    height: 26.26,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2694444444444446
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 207.18,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220.31,
    width: 22.85,
    height: 28.17,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9041666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 234.395,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 248.48,
    width: 22.85,
    height: 28.66,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9041666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 262.81,
    fontFamily: "Arial"
  }, "\n        Emporia_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.14,
    width: 22.85,
    height: 29.7,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5233333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 291.99,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 306.85,
    width: 22.85,
    height: 29.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5233333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 321.785,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 336.72,
    width: 22.85,
    height: 30.34,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 351.89000000000004,
    fontFamily: "Arial"
  }, "\n        Galax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 367.05,
    width: 22.85,
    height: 30.37,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9041666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 382.235,
    fontFamily: "Arial"
  }, "\n        Bedford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 397.42,
    width: 22.85,
    height: 30.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6321428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 412.65500000000003,
    fontFamily: "Arial"
  }, "\n        Lexington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 427.89,
    width: 22.85,
    height: 31.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9041666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 443.46999999999997,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 459.05,
    width: 22.85,
    height: 31.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5233333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 474.78000000000003,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 490.51,
    width: 22.85,
    height: 32.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7576923076923079
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 506.545,
    fontFamily: "Arial"
  }, "\n        Franklin_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 522.58,
    width: 22.85,
    height: 34.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9041666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 540.01,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 557.44,
    width: 22.85,
    height: 34.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3441176470588236
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 574.9100000000001,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.38,
    width: 22.85,
    height: 35.2,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2694444444444446
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 609.98,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.58,
    width: 22.85,
    height: 36.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.428125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 645.605,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 663.63,
    width: 22.85,
    height: 36.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7576923076923079
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.425,
    y: 681.8149999999999,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 0,
    width: 25.93,
    height: 32.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.852142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.815,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.77,
    y: 0,
    width: 26.6,
    height: 32.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5647058823529412
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.07000000000001,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        South_Boston_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.38,
    y: 0,
    width: 26.83,
    height: 32.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.063846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.79499999999999,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.2,
    y: 0,
    width: 26.92,
    height: 32.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7946666666666669
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.66,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.12,
    y: 0,
    width: 27.16,
    height: 32.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4294736842105262
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.70000000000002,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.28,
    y: 0,
    width: 29.3,
    height: 32.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6277777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.93,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.58,
    y: 0,
    width: 30.5,
    height: 32.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1785714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.83,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.08,
    y: 0,
    width: 30.61,
    height: 32.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1864285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.38500000000002,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Covington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.7,
    y: 0,
    width: 31.38,
    height: 32.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6149999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.39,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Suffolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.08,
    y: 0,
    width: 31.74,
    height: 32.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8670588235294117
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.95,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Williamsburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.81,
    y: 0,
    width: 32.59,
    height: 32.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5069230769230773
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.105,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.4,
    y: 0,
    width: 32.79,
    height: 32.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.79499999999996,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.19,
    y: 0,
    width: 33.27,
    height: 32.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.568095238095238
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.825,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.46,
    y: 0,
    width: 34.23,
    height: 32.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9370588235294117
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.575,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.69,
    y: 0,
    width: 35.62,
    height: 32.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.058125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.5,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.31,
    y: 0,
    width: 36.07,
    height: 32.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.733157894736842
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.345,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.37,
    y: 0,
    width: 36.27,
    height: 32.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.505,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.64,
    y: 0,
    width: 36.39,
    height: 32.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.058125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.835,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.04,
    y: 0,
    width: 36.4,
    height: 32.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9370588235294117
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.24,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.44,
    y: 0,
    width: 38.24,
    height: 32.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.058125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 642.5600000000001,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 661.69,
    y: 0,
    width: 38.31,
    height: 32.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7441666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.845,
    y: 16.465,
    fontFamily: "Arial"
  }, "\n        Radford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 32.93,
    width: 39.29,
    height: 32.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.020625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 49.095,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 65.26,
    width: 39.29,
    height: 32.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.04875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 81.65,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 98.04,
    width: 39.29,
    height: 32.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.537692307692308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 114.53500000000001,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 131.03,
    width: 39.29,
    height: 33.11,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.546923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 147.585,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 164.15,
    width: 39.29,
    height: 33.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8511111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 180.81,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 197.47,
    width: 39.29,
    height: 33.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.776666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 214.13,
    fontFamily: "Arial"
  }, "\n        Bristol_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 230.79,
    width: 39.29,
    height: 33.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2546666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 247.7,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 264.6,
    width: 39.29,
    height: 34.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.636923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 281.74,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 298.88,
    width: 39.29,
    height: 34.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.459285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 316.09499999999997,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 333.31,
    width: 39.29,
    height: 34.67,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0394117647058825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 350.645,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 367.99,
    width: 39.29,
    height: 37.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.492
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 386.68,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 405.36,
    width: 39.29,
    height: 40.17,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.311176470588235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 425.445,
    fontFamily: "Arial"
  }, "\n        Harrisonburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 445.53,
    width: 39.29,
    height: 41.14,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.182777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 466.09999999999997,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 486.67,
    width: 39.29,
    height: 41.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 507.425,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 528.18,
    width: 39.29,
    height: 42.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.311176470588235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 549.3349999999999,
    fontFamily: "Arial"
  }, "\n        Falls_Church_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 570.49,
    width: 39.29,
    height: 42.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.067894736842105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 591.785,
    fontFamily: "Arial"
  }, "\n        Fredericksburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 613.08,
    width: 39.29,
    height: 43.34,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.311176470588235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 634.75,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.85,
    y: 656.42,
    width: 39.29,
    height: 43.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.619333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.495000000000005,
    y: 678.2099999999999,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 32.93,
    width: 39.5,
    height: 44.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.46875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.89,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 32.93,
    width: 39.51,
    height: 44.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.822142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.395,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.15,
    y: 32.93,
    width: 39.68,
    height: 44.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.99,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.82,
    y: 32.93,
    width: 40.04,
    height: 44.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6693333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.84,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Waynesboro_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.86,
    y: 32.93,
    width: 40.06,
    height: 44.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.081538461538462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.89000000000001,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.93,
    y: 32.93,
    width: 40.69,
    height: 44.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.393529411764706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.275,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.62,
    y: 32.93,
    width: 40.7,
    height: 44.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.142105263157895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.97,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.32,
    y: 32.93,
    width: 40.99,
    height: 44.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.561875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.815,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.31,
    y: 32.93,
    width: 42.67,
    height: 44.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5558333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.645,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.98,
    y: 32.93,
    width: 44.72,
    height: 44.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.065454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.34000000000003,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.71,
    y: 32.93,
    width: 44.86,
    height: 44.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.243
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.14,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.57,
    y: 32.93,
    width: 45.08,
    height: 44.97,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.11,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.65,
    y: 32.93,
    width: 46,
    height: 44.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9979999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.65,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Winchester_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 606.65,
    y: 32.93,
    width: 46.04,
    height: 44.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.67,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.69,
    y: 32.93,
    width: 47.31,
    height: 44.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6452941176470586
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.345,
    y: 55.415,
    fontFamily: "Arial"
  }, "\n        Martinsville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 77.9,
    width: 49.93,
    height: 43.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.720625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 99.665,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 121.43,
    width: 49.93,
    height: 44.72,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1942857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 143.79000000000002,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 166.15,
    width: 49.93,
    height: 46.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0866666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 189.3,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 212.44,
    width: 49.93,
    height: 46.42,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5707692307692307
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 235.65,
    fontFamily: "Arial"
  }, "\n        Hopewell_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 258.86,
    width: 49.93,
    height: 47.08,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3628571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 282.40000000000003,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 305.94,
    width: 49.93,
    height: 47.61,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6623076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 329.745,
    fontFamily: "Arial"
  }, "\n        Staunton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 353.55,
    width: 49.93,
    height: 47.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1926666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 377.495,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 401.44,
    width: 49.93,
    height: 48.09,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.005625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 425.485,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 449.53,
    width: 49.93,
    height: 48.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4635714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 473.775,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 498.02,
    width: 49.93,
    height: 48.59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2393333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 522.3149999999999,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 546.61,
    width: 49.93,
    height: 50.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.160833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 571.785,
    fontFamily: "Arial"
  }, "\n        Fairfax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 596.96,
    width: 49.93,
    height: 50.88,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.993
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 622.4000000000001,
    fontFamily: "Arial"
  }, "\n        Salem_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 647.84,
    width: 49.93,
    height: 52.16,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.160833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.105,
    y: 673.9200000000001,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 77.9,
    width: 47.74,
    height: 55.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.774
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.94,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.81,
    y: 77.9,
    width: 47.83,
    height: 55.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4164285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.725,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.64,
    y: 77.9,
    width: 51.09,
    height: 55.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6492857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.185,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 77.9,
    width: 51.4,
    height: 55.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.43,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.14,
    y: 77.9,
    width: 51.95,
    height: 55.96,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0558823529411767
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.115,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.08,
    y: 77.9,
    width: 52.41,
    height: 55.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7435714285714283
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 388.28499999999997,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.49,
    y: 77.9,
    width: 53.29,
    height: 55.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.440833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.135,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.79,
    y: 77.9,
    width: 54.24,
    height: 55.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.91,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.03,
    y: 77.9,
    width: 55.94,
    height: 55.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1077777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.97,
    y: 77.9,
    width: 59.89,
    height: 55.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9971428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.9150000000001,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        Nansemond_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.86,
    y: 77.9,
    width: 62.14,
    height: 55.96,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.087272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.9300000000001,
    y: 105.88000000000001,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 133.86,
    width: 64.01,
    height: 56.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7366666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 161.88500000000002,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 189.91,
    width: 64.01,
    height: 58.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.196428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 219.285,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 248.65,
    width: 64.01,
    height: 59.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 278.185,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 307.72,
    width: 64.01,
    height: 63.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.264166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 339.305,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 370.9,
    width: 64.01,
    height: 63.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2219999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 402.565,
    fontFamily: "Arial"
  }, "\n        Petersburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 434.22,
    width: 64.01,
    height: 63.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7429411764705884
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 466.035,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 497.85,
    width: 64.01,
    height: 64.49,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.765294117647059
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 530.095,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 562.35,
    width: 64.01,
    height: 68.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.000625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 596.375,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 630.39,
    width: 64.01,
    height: 69.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.765294117647059
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.075,
    y: 665.1949999999999,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.07,
    y: 133.86,
    width: 65.83,
    height: 68.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.98499999999999,
    y: 167.97000000000003,
    fontFamily: "Arial"
  }, "\n        Charlottesville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.9,
    y: 133.86,
    width: 66.84,
    height: 68.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.774285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.32,
    y: 167.97000000000003,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.74,
    y: 133.86,
    width: 67.36,
    height: 68.22,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.811428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.42,
    y: 167.97000000000003,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.1,
    y: 133.86,
    width: 69.79,
    height: 68.22,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.548
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 410.995,
    y: 167.97000000000003,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.89,
    y: 133.86,
    width: 82.51,
    height: 68.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.590526315789474
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.145,
    y: 167.97000000000003,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.41,
    y: 133.86,
    width: 83.4,
    height: 68.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.247692307692308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.11,
    y: 167.97000000000003,
    fontFamily: "Arial"
  }, "\n        Danville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.8,
    y: 133.86,
    width: 88.2,
    height: 68.22,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.872857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.9,
    y: 167.97000000000003,
    fontFamily: "Arial"
  }, "\n        Lynchburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.07,
    y: 202.08,
    width: 92.98,
    height: 93.24,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.56,
    y: 248.70000000000002,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.07,
    y: 295.31,
    width: 92.98,
    height: 94.33,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.198666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.56,
    y: 342.475,
    fontFamily: "Arial"
  }, "\n        Chesapeake_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.07,
    y: 389.64,
    width: 92.98,
    height: 100.85,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.427619047619048
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.56,
    y: 440.065,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.07,
    y: 490.5,
    width: 92.98,
    height: 103.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.748333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.56,
    y: 542.35,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.07,
    y: 594.2,
    width: 92.98,
    height: 105.8,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.893684210526316
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.56,
    y: 647.1,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.05,
    y: 202.08,
    width: 99.88,
    height: 112.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.323333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.99,
    y: 258.37,
    fontFamily: "Arial"
  }, "\n        Hampton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.93,
    y: 202.08,
    width: 102.61,
    height: 112.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8406666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.235,
    y: 258.37,
    fontFamily: "Arial"
  }, "\n        Portsmouth_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.54,
    y: 202.08,
    width: 108.04,
    height: 112.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.202666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.5600000000001,
    y: 258.37,
    fontFamily: "Arial"
  }, "\n        Alexandria_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.58,
    y: 202.08,
    width: 120.42,
    height: 112.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.62235294117647
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.7900000000001,
    y: 258.37,
    fontFamily: "Arial"
  }, "\n        Newport_News_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.05,
    y: 314.66,
    width: 155.22,
    height: 107.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.671052631578948
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.66,
    y: 368.535,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.05,
    y: 422.41,
    width: 155.22,
    height: 134.12,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.66,
    y: 489.47,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.05,
    y: 556.53,
    width: 155.22,
    height: 143.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.955833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.66,
    y: 628.265,
    fontFamily: "Arial"
  }, "\n        Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.27,
    y: 314.66,
    width: 124.78,
    height: 178.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.79875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.65999999999997,
    y: 404.115,
    fontFamily: "Arial"
  }, "\n        Arlington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.06,
    y: 314.66,
    width: 150.94,
    height: 178.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.61076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.53,
    y: 404.115,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.27,
    y: 493.57,
    width: 275.73,
    height: 206.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.745000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.135,
    y: 596.785,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1972);
export default __webpack_public_path__ + "static/media/1972.e9e41c68a97642120eb163ea63fa9f33.svg";
export { ForwardRef as ReactComponent };